
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import AccountCodeLogin from './accountCodeLogin.vue'

import moment from 'moment'

import type { XTUCPhone4JMemberOptions } from '@xt/client/entities/user/controller'

@Observer
@Component({
  components: {
    HeaderImage,
    AccountCodeLogin
  }
})
export default class ChooseAccount extends Vue {
  @Prop({ required: true }) memberAccount: Array<XTUCPhone4JMemberOptions>

  @Prop({ required: true }) bindType: 'phone' | 'email'

  // 触发绑定新的账号
  isAccountCodeLogin: boolean = false

  getAccountTypeLabel(accountType: number) {
    return accountType === 1 ? '微信号' : accountType === 2 ? '手机号' : '邮箱'
  }

  getAccountTypeImage(accountType: number) {
    return accountType === 1
      ? this.$images.account_wechat_ico
      : accountType === 2
        ? this.$images.account_phone_ico
        : this.$images.account_email_ico
  }

  get mainBtnLabel() {
    return this.memberAccount.length === 1 ? '登录该账号' : this.bindType === 'phone' ? '登录手机账号' : '登录邮箱账号'
  }

  get subBtnLabel() {
    return this.bindType === 'phone' ? '绑定新的手机号' : '绑定新的邮箱'
  }

  get bindAccount() {
    const item = this.memberAccount.filter(x => x.accountType !== 1)[0]

    if (!item) {
      return null
    }

    return this.bindType === 'phone' ? item.phoneNum : item.email
  }

  getAccountMessage(item: XTUCPhone4JMemberOptions) {
    const year = moment(item.registeredTime).utcOffset(+8).format('YYYY')
    const desc = item.accountType === 1 ? '未绑定手机号/邮箱' : item.bingWx ? '已绑定微信' : '未绑定微信'

    return `${year}年注册 | ${desc}`
  }

  handleBindNewAccount() {
    this.isAccountCodeLogin = true
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
